"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeletedPushNotification = void 0;
var runtypes_1 = require("runtypes");
exports.DeletedPushNotification = (0, runtypes_1.Record)({
    type: (0, runtypes_1.Literal)("deleted"),
    uuid: runtypes_1.String,
});
//# sourceMappingURL=DeletedPushNotification.js.map